import React, { useState, useRef, useEffect, useLayoutEffect } from "react";
import { createPortal } from "react-dom";
import { useAuth } from "../contexts/AuthContext";

export default function ProfileMenu() {
  const { user, signOut } = useAuth();
  const [open, setOpen] = useState(false);
  const [position, setPosition] = useState({ left: 0, top: 0 });
  const menuRef = useRef(null);
  const buttonRef = useRef(null);
  const portalRef = useRef(null);

  // When opening, read button position for portal placement (before paint)
  useLayoutEffect(() => {
    if (!open || !buttonRef.current) return;
    const rect = buttonRef.current.getBoundingClientRect();
    const menuWidth = 200;
    const clampedLeft = Math.min(rect.left, window.innerWidth - menuWidth - 8);
    setPosition({
      left: Math.max(8, clampedLeft),
      top: rect.bottom + 4,
    });
  }, [open]);

  // Close when clicking outside (button/wrapper or portal dropdown)
  useEffect(() => {
    if (!open) return;
    const handler = (e) => {
      const inMenu = menuRef.current?.contains(e.target);
      const inPortal = portalRef.current?.contains(e.target);
      if (!inMenu && !inPortal) setOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [open]);

  if (!user) return null;

  const initial = (user.email || "?")[0].toUpperCase();

  const dropdownContent = (
    <div
      ref={portalRef}
      className="profile-dropdown-portal-wrapper"
      style={{
        position: "fixed",
        left: position.left,
        top: position.top,
        zIndex: 200,
      }}
    >
      <div className="profile-dropdown profile-dropdown-portal">
        <div className="profile-dropdown-email">{user.email}</div>
        <div className="profile-dropdown-divider" />
        <button
          type="button"
          className="profile-dropdown-item profile-dropdown-signout"
          onClick={() => {
            setOpen(false);
            signOut();
          }}
        >
          Sign out
        </button>
      </div>
    </div>
  );

  return (
    <div className="profile-menu-wrapper" ref={menuRef}>
      {open && position.top > 0 && createPortal(dropdownContent, document.body)}
      <button
        ref={buttonRef}
        type="button"
        className="profile-avatar-btn"
        onClick={() => setOpen((v) => !v)}
        title={user.email}
        aria-label="Account menu"
      >
        {initial}
      </button>
    </div>
  );
}
